<template>
	<div :class="{hidden: hidden}" class="pagination-container">
		<el-pagination
			:background="background"
			:current-page.sync="currentPage"
			:page-size.sync="pageSize"
			:layout="layout"
			prev-text="上一页"
			next-text="下一页"
			:page-sizes="pageSizes"
			:total="total"
			v-bind="$attrs"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
		/>
	</div>
</template>

<script>
import {scrollTo} from "@/utils/scroll-to"

export default {
	name: "Pagination",
	props: {
		total: {
			required: true,
			type: Number
		},
		page: {
			type: Number,
			default: 1
		},
		limit: {
			type: Number,
			default: 20
		},
		pageSizes: {
			type: Array,
			default() {
				return [10, 20, 30, 50]
			}
		},
		layout: {
			type: String,
			default: "total, sizes, prev, pager, next, jumper"
		},
		background: {
			type: Boolean,
			default: true
		},
		autoScroll: {
			type: Boolean,
			default: true
		},
		hidden: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		currentPage: {
			get() {
				return this.page
			},
			set(val) {
				this.$emit("update:page", val)
			}
		},
		pageSize: {
			get() {
				return this.limit
			},
			set(val) {
				this.$emit("update:limit", val)
			}
		}
	},
	mounted() {
		// document.getElementsByClassName("btn-prev")[0].innerHTML =
		// 	'<div style="display:flex;flex:1;vertical-align:middle;line-height:28px;"><i class="el-icon el-icon-arrow-left"></i>上一页</div>'
		// console.log(document.getElementsByClassName("btn-prev")[0].innerHTML)
	},
	methods: {
		handleSizeChange(val) {
			console.log(val)
			this.$emit("pagination", {page: this.currentPage, limit: val})
			if (this.autoScroll) {
				scrollTo(0, 800)
			}
		},
		handleCurrentChange(val) {
			console.log(val)
			this.$emit("pagination", {page: val, limit: this.pageSize})
			if (this.autoScroll) {
				scrollTo(0, 800)
			}
		}
	}
}
</script>

<style scoped>
.pagination-container {
	/* background: #fff; */
	/* padding: 32px 16px; */
	padding: 20px 16px;
}
.pagination-container.hidden {
	display: none;
}
::v-deep.el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #fe7648 !important;
	color: #ffffff;
}
::v-deep.el-pagination.is-background .el-pager li {
	margin: 0 5px;
	background-color: #e8e8e8 !important;
	color: #606266;
	min-width: 30px;
	border-radius: 2px;
}
::v-deep .btn-prev {
	/* padding: 0 4px; */

	padding: 0 10px !important;
	text-align: center;
	background: #e8e8e8 !important;
}
::v-deep .btn-next {
	padding: 0 10px !important;
	text-align: center;
	background: #e8e8e8 !important;
}
</style>
